module.exports = __webpack_public_path__ + "static/img/ydh2_title_bg.74cef407.png";